import React, { useEffect, useState } from "react";
import StartAndEndDateFilter from "../GlobalComponents/StartAndEndDateFilter";
import SelectDropdown from "../GlobalComponents/SelectDropdown";
import CustomerTableWrapper from "../Customer/CustomerTableWrapper";
import httpRequest from "src/helpers/httpRequest";
import {
  IAppointmentItems,
  IDropDownArray,
  IqueryParams,
} from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import { Link } from "react-router-dom";
import moment from "moment";
import qs from "qs";
import Cookies from "js-cookie";
import {
  CURRENCY,
  customer,
  doctor,
  doctorMode,
  statusColor,
} from "src/lib/constans";
import { toast } from "react-toastify";
import eyeIcon from "src/assets/images/eye-icon-green.png";
import { displayStatus } from "src/helpers/helperFunctions";
import CustomWebsiteDropdown from "../GlobalComponents/Widget/CustomWebsiteDropdown";

interface IMyAppointmentResponse {
  documents: IAppointmentItems[];
  paginated: IPaginated;
} // Interface for the API response containing appointments and pagination info

const statusList: IDropDownArray[] = [
  { label: "Pending", value: "pending" },
  { label: "Complete", value: "completed" },
  { label: "Cancelled", value: "cancelled" },
];

const MyOnlineAppointments: React.FC = () => {
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [data, setData] = useState<IAppointmentItems[]>([]);
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
    role: doctor,
    isOnline: true,
    startDate: "",
    endDate: "",
    status: "",
  }); // Query parameters for API request
  const [status, setStatus] = useState<string>("");
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  }); // Pagination state

  const handlePageChange = (e: number) => {
    setQueryParams((prev) => ({
      ...prev,
      page: e,
    }));
  };

  // Function to apply date range filters
  const applyFilter = (startDate: string, endDate: string) => {
    setQueryParams((prev) => ({
      ...prev,
      page: 1,
      startDate,
      endDate,
      status,
    }));
  };

  // Function to reset date range filters
  const resetFilter = () => {
    setQueryParams((prev) => ({
      ...prev,
      page: 1,
      startDate: "",
      endDate: "",
      status: "",
    }));
    setStatus("");
  };

  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IMyAppointmentResponse>({
      path: `/appoiment/booking?${qs.stringify(queryParams)}`,
    });
    if (res) {
      const { documents = [], paginated } = res;
      setData(documents);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" }); // Show error toast if API call fails
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetch();
  }, [queryParams]);
  return (
    <>
      <div className="flex items-center gap-3">
        <CustomWebsiteDropdown
          options={statusList}
          setData={(data: IDropDownArray[]) => setStatus(data[0]?.value || "")}
          data={statusList.filter((v) => v.value === status)}
          extraClass={""}
          placeholder="Filter by Status"
          dropdownMainId="status-dropdown"
          mainDivClass="!w-fit min-w-[180px]"
          withoutMargin
        />
        <StartAndEndDateFilter reset={resetFilter} apply={applyFilter} />
      </div>
      <hr className="my-4" />
      <CustomerTableWrapper
        isLoading={isLoader}
        thead={[
          "S.No",
          "Customer Name",
          "Fee",
          "Time ",
          "Status",
          "Date",
          "View Details",
        ]}
        page={paginated.currentPage || 1}
        total={paginated.totalPages || 0}
        columnWidth={"10% 20% 10% 20% 15% 11% 14%"}
        onChange={handlePageChange}
      >
        {data?.map((item: IAppointmentItems, index: number) => (
          <ul
            key={index}
            className={`font-size-16px tbody-light-table customer-table-wrapper-body-padding-non customer-table-wrapper-body tbody-light-table-customer font-Poppins-Regular grid ${
              !item?.doctorNotified ? "font-bold" : ""
            }`}
            style={{ gridTemplateColumns: "10% 20% 10% 20% 15% 11% 14%" }}
          >
            <li style={{ paddingLeft: "2rem" }}>
              {((paginated?.currentPage - 1) * queryParams.limit + (index + 1)).toString().padStart(2, "0")}
            </li>
            <li className="capitalize">{`${item.firstName} ${item.lastName}`}</li>
            <li>
              {CURRENCY} {item.fees}
            </li>
            <li>{`${moment(item.startTime, "HH:mm").format(
              "h:mm A"
            )} to ${moment(item.endTime, "HH:mm").format("h:mm A")}`}</li>
            <li>
              <span
                className="py-1 px-4 text-white capitalize rounded"
                // style={{

                //     backgroundColor:
                //         item.status === "pending" ? statusColor.yellow
                //             : item.status === "completed" ? statusColor.green
                //                 : item.status === "cancelled" ? "red"
                //                     : ""
                // }}
                style={{
                  backgroundColor: displayStatus(item?.status)?.bgColor,
                  color: displayStatus(item?.status)?.color,
                }}
              >
                {item.status}
              </span>
            </li>
            <li>{moment(item.appoinmentDate).format("DD-MM-YYYY")}</li>
            <li className="action-last-colum">
              <Link
                id={`view-appointment-btn-${index + 1}`}
                to={`/doctor/appointment/${item?._id}/view`}
              >
                <img src={eyeIcon} alt="" />
              </Link>
            </li>
          </ul>
        ))}
      </CustomerTableWrapper>
    </>
  );
};

export default MyOnlineAppointments;
